import axios from "axios";
import {Base_URL} from "../url"   


// const API_URL = "http://192.168.29.242:5090/api/EventDetails/SaveEvents";

export const saveEventDetails = async (eventData) => {
  try {
    const response = await axios.post(`${Base_URL}/EventDetails/SaveEvents`, eventData, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to save event";
  }
};
